/* eslint-env jest */
import PromoBanner from './index';

// PromoBanner is a pure function component (no hooks), so we invoke it directly and
// read the text out of the returned element tree.
const textOf = (node, acc = []) => {
  if (node == null || node === false) return acc;
  if (typeof node === 'string' || typeof node === 'number') {
    acc.push(String(node));
    return acc;
  }
  if (Array.isArray(node)) {
    node.forEach((n) => textOf(n, acc));
    return acc;
  }
  if (node.props && node.props.children != null) textOf(node.props.children, acc);
  return acc;
};
const render = (offer) => textOf(PromoBanner({ offer, className: '' })).join(' ');

describe('PromoBanner', () => {
  it('renders nothing without an offer', () => {
    expect(PromoBanner({ offer: null, className: '' })).toBeNull();
  });

  it('shows the admin promoHeadline when set', () => {
    expect(render({
      promoHeadline: 'Save big today', couponType: 'PERCENTAGE', value: 20, code: 'X',
    })).toContain('Save big today');
  });

  it('falls back to offerLine when promoHeadline is absent (offer + code stay visible)', () => {
    const text = render({ couponType: 'PERCENTAGE_WITH_FREE_SHIPPING', value: 20, code: 'FALL20' });
    expect(text).toContain('20% off');
    expect(text).toContain('free shipping');
    expect(text).toContain('FALL20');
  });

  // UPDATED for #4667. This example previously asserted that a flat-rate coupon rendered
  // nothing, on the premise that a flat coupon had "nothing derivable". #4667 taught
  // offerPricing to derive a credit line, so a flat coupon IS derivable now and the banner
  // correctly shows it -- which is the whole point of that change: the cards show the credit
  // but not the CODE, so without this banner a flat coupon would have its code nowhere.
  // The component's own contract comment states the rule: "Renders nothing only when there's
  // no offer AND nothing derivable." The test was left behind; the code is right. (#4673)
  it('derives a credit line for a flat-rate coupon with no headline', () => {
    const text = render({ couponType: 'FLAT_RATE', value: 5, code: 'X' });

    expect(text).toContain('$5 credit');
    expect(text).toContain('X');
  });

  it('renders nothing when there is no offer at all', () => {
    expect(PromoBanner({ offer: null, className: '' })).toBeNull();
    expect(PromoBanner({ offer: undefined, className: '' })).toBeNull();
  });
});
